/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';

function LegalAndFinances({ mainColor, secondaryColor }) {
  return (
    <svg
      width="157"
      height="157"
      viewBox="0 0 157 157"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="78.5"
        cy="78.5"
        r="77.5"
        fill={mainColor}
        stroke="white"
        stroke-width="2"
      />
      <path
        d="M44.809 119.539C56.3493 121.639 69.9998 120.633 81.658 119.347C83.9749 119.095 90.7633 117.661 91.3683 114.732C92.8736 107.411 66.2219 107.588 62.7097 107.603C59.3745 107.618 33.4312 108.12 37.0172 115.664C37.9764 117.734 41.164 118.888 44.809 119.539Z"
        fill={secondaryColor}
      />
      <path
        d="M90.4973 119.687C87.1474 121.58 82.6907 122.157 81.9528 122.231C75.9761 122.896 68.0662 123.651 60.053 123.651C54.0911 123.651 48.9408 123.237 44.2774 122.394C40.6324 121.728 38.0056 120.693 36.2642 119.243C34.9213 125.588 38.8468 127.881 44.6464 128.946C56.1866 131.046 69.8371 130.04 81.4954 128.754C83.8123 128.502 90.6006 127.067 91.2057 124.139C91.5894 122.246 91.8993 121.373 90.94 119.687H90.4973Z"
        fill={secondaryColor}
      />
      <path
        d="M117.864 84.8187L95.6569 65.9874L104.757 56.8671C105.36 57.4718 106.179 57.8115 107.032 57.8115C107.885 57.8115 108.703 57.4718 109.307 56.8671L113.857 52.3069C114.46 51.7022 114.799 50.882 114.799 50.0269C114.799 49.1717 114.46 48.3515 113.857 47.7468L91.1067 24.9444C90.5033 24.3397 89.685 24 88.8317 24C87.9784 24 87.1601 24.3397 86.5567 24.9444L82.0067 29.5046C81.708 29.804 81.4709 30.1595 81.3092 30.5507C81.1475 30.942 81.0643 31.3613 81.0643 31.7848C81.0643 32.2083 81.1475 32.6276 81.3092 33.0189C81.4709 33.4101 81.708 33.7656 82.0067 34.065L54.707 61.4259C54.4083 61.1265 54.0536 60.8889 53.6632 60.7268C53.2728 60.5648 52.8544 60.4814 52.4319 60.4814C52.0094 60.4814 51.591 60.5648 51.2006 60.7268C50.8102 60.8889 50.4555 61.1265 50.1568 61.4259L45.6068 65.9861C45.0035 66.5908 44.6645 67.411 44.6645 68.2662C44.6645 69.1214 45.0035 69.9415 45.6068 70.5462L68.3569 93.3473C68.9603 93.952 69.7786 94.2917 70.6319 94.2917C71.4851 94.2917 72.3035 93.952 72.9068 93.3473L77.4568 88.7872C78.0601 88.1824 78.3991 87.3623 78.3991 86.5071C78.3991 85.6519 78.0601 84.8317 77.4568 84.227L86.5567 75.1067L105.346 97.3632C106.14 98.3018 107.119 99.0653 108.222 99.6055C109.325 100.146 110.528 100.451 111.755 100.501C112.981 100.552 114.205 100.347 115.349 99.8998C116.492 99.4524 117.531 98.7722 118.399 97.9022C119.267 97.0321 119.946 95.9911 120.392 94.8449C120.839 93.6987 121.043 92.4721 120.992 91.2427C120.942 90.0133 120.638 88.8078 120.099 87.7023C119.56 86.5967 118.8 85.6142 117.864 84.8187Z"
        fill={secondaryColor}
      />
    </svg>
  );
}
LegalAndFinances.propTypes = {
  mainColor: PropTypes.string,
  secondaryColor: PropTypes.string,
};
LegalAndFinances.defaultProps = {
  mainColor: '#7ED321',
  secondaryColor: '#FFFFFF',
};
const memoized = React.memo(LegalAndFinances);
memoized.displayName = 'LegalAndFinances';
export default memoized;
